import React from 'react';
import styled from 'styled-components';

import * as Buttons from 'theme/components/Buttons.style';
import * as Modal from 'theme/components/Modal.style';
import * as Text from 'theme/components/Text.style';

interface ConfirmDialogProps {
  cancelLabel?: string;
  contentText?: string;
  handleClose: () => void;
  isOpen: boolean;
  successCallback?: () => void;
  successLabel?: string;
  title?: string;
}

const Card = styled('div')`
  align-items: center;
  background-color: white;
  border-radius: 40px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 40px;
  justify-content: center;
  max-width: 90vw;
  padding: 40px 20px 20px;
  width: 420px;
`;

const TextGroup = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
`;

const Title = styled(Text.H3)`
  text-align: center;
  width: 100%;
`;

const Description = styled(Text.P2)`
  text-align: center;
  width: 100%;
`;

const Actions = styled('div')`
  display: flex;
  gap: 10px;
  width: 100%;
`;

const ConfirmDialog = ({
  cancelLabel,
  contentText,
  handleClose,
  isOpen,
  successCallback,
  successLabel,
  title,
}: ConfirmDialogProps): JSX.Element => (
  <Modal.Container onClose={handleClose} open={isOpen} PaperComponent={Card}>
    <TextGroup>
      {title && <Title id="alert-dialog-title">{title}</Title>}
      {contentText && (
        <Description id="alert-dialog-description">{contentText}</Description>
      )}
    </TextGroup>
    <Actions>
      <Buttons.SecondaryLight $size="medium" onClick={handleClose} stretch>
        {cancelLabel}
      </Buttons.SecondaryLight>
      {successCallback && (
        <Buttons.Primary $size="medium" onClick={successCallback} stretch>
          {successLabel}
        </Buttons.Primary>
      )}
    </Actions>
  </Modal.Container>
);

export default ConfirmDialog;
